import styled from '@emotion/styled';
import type { ReactNode } from 'react';

const BodyContainer = styled.div`
  font:
    12px/18px 'メイリオ',
    Meiryo,
    'ＭＳ Ｐゴシック',
    'MS PGothic',
    'ヒラギノ角ゴ Pro W3',
    'Hiragino Kaku Gothic Pro',
    Osaka,
    sans-serif,
    'Lucida Grande',
    'Lucida Sans Unicode',
    Helvetica,
    Arial,
    Verdana;
  background: url(images/back_paper.png) repeat;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export function Body({ children }: { children: ReactNode }) {
  return <BodyContainer>{children}</BodyContainer>;
}
